import { Cartouche } from '@brig/theme/components';
import { CompassRose } from '@brig/theme/ornaments';
import { button, paper } from '@brig/theme/styles';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router';
import { useMe, useUpdateMe } from '../api/hooks.ts';
import { useAuth } from '../auth/useAuth.ts';
import { LanguageSwitcher } from '../components/LanguageSwitcher.tsx';
import { HowToPlay } from '../learn/HowToPlay.tsx';
import { isTopic } from '../learn/topics.ts';
import { useDocumentTitle } from '../useDocumentTitle.ts';
import * as styles from './HowToPlayPage.css.ts';

/**
 * "How to play" open to guests (docs/ux.md Q-UX-08): a friend invited by link can read it before
 * signing in. Each topic has its own address, so a page can be linked to. It sits outside the
 * app shell, so it carries its own way home and its own language switcher.
 */
export function HowToPlayPage() {
  const { t } = useTranslation();
  useDocumentTitle(t('learn.pageTitle'));
  const navigate = useNavigate();
  const { topic } = useParams();
  const { status } = useAuth();
  const { data: me } = useMe(status === 'authenticated');
  const updateMe = useUpdateMe();
  return (
    <main className={styles.sea}>
      <header className={styles.topBar}>
        <Link to="/" className={styles.brand}>
          <CompassRose size={40} northLabel="" ink="#2F2418" paper="#F1E6C8" accent="#A8863F" />
          <span className={styles.brandName}>{t('app.shortName')}</span>
        </Link>
        <LanguageSwitcher
          onChange={(locale) => {
            if (me && me.locale !== locale) updateMe.mutate({ locale });
          }}
        />
      </header>
      <section className={`${paper} ${styles.sheet}`}>
        <Cartouche subtitle={t('learn.lead')}>{t('learn.title')}</Cartouche>
        <HowToPlay
          topic={isTopic(topic) ? topic : 'goal'}
          onTopic={(next) => {
            void navigate(`/how-to-play/${next}`, { replace: true });
          }}
        />
        <Link to="/" className={`${button({ tone: 'seal' })} ${styles.back}`}>
          {t('learn.back')}
        </Link>
      </section>
    </main>
  );
}
